<template>
  <div class="about-wrapper">
    <Header :has-section-title="true" title="About"></Header>
    <Menu :is-open="isMenuOpen" @toggleMenu="toggleMenu"></Menu>
    <main class="about">
      <div class="about__photo-wrapper">
        <img
          class="about__photo"
          src="~@/assets/images/about.jpg"
        />
      </div>
      <div class="about__info info">
        <h2 class="info__title">My Story</h2>
        <p class="info__description">
          Hello dear reader, my name is Anna.
          I was born in Ukraine, in a small, but well-known city by lovers of world literature called Kaniv. Ukrainians are open and good-natured people who do not skimp on expressing emotions. It affected my work. In my works I try to convey what I am used to seeing around me which are human feelings and emotions. Love, joy, carefree, honesty and sincerity of the moment is what I create in my works.
        </p>
        <p class="info__description">During my photoshoots, my task is not to capture the “accidentally” staged moments caught in the lens, but to recreate for my clients just such an atmosphere in which I can take a picture at any moment and it will turn out to be real and vital.
        </p>
         <p class="info__description">I love to travel, especially with my clients to wherever your special moments take us. Look around the site, check out my work and I look forward to speaking with you soon❤️
        </p>
      </div>
      <Button className="about__button button--withArrow" to="/portfolio" :with-arrow=true>Portfolio</Button>
    </main>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "../components/Header";
import Footer from "../components/Footer";
import Menu from "../components/Menu";
import Button from "../components/Button";
import { MenuMixin } from "../mixins";

export default {
  mixins: [MenuMixin],
  components: { Header, Footer, Menu, Button }
};
</script>
